

let initialState =  0;

const playerfilter = (state = initialState, action) => {

    switch(action.type){ 
      case "PLAYERFILTER" : return action.parm;
      case "RESET": return initialState; //Always return the initial state
      default : return state;
  }
}

export default playerfilter